module.exports = __webpack_public_path__ + "img/enabled.1447aa7a.svg";